import translationEN from '../../assets/locales/en/translation.json';
import translationFR from "../../assets/locales/fr/translation.json";
import translationPL from "../../assets/locales/pl/translation.json";

import FormControlLabel from '@mui/material/FormControlLabel';
import Switch from '@mui/material/Switch';
import { enqueueSnackbar } from 'notistack';
import {State} from '../../components/grid/BasicGridState'

import SearchIcon from "@mui/icons-material/Search";
import ClearIcon from "@mui/icons-material/Clear";

import 'font-awesome/css/font-awesome.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap';
import 'flatpickr/dist/flatpickr.min.css';

import '../../components/grid/styles.scss';
import '../../components/grid/slickgrid.scss';
import '../../layouts/gridlayout.css'
import i18next, { TFunction } from 'i18next';

import PlanService from "../../services/plan/plan.service";
import { ColorWallEditor } from '../../components/grid/CustomEditors/ColorWallEditor';
import { ColorStandEditor } from '../../components/grid/CustomEditors/ColorStandEditor';

import {
   SlickgridReact, FieldType, Filters,
   GridOption,
  Column, Formatter, Formatters,
  Editors, EditCommand, 
  CompositeEditorModalType, OnCompositeEditorChangeEventArgs, CompositeEditorSelection,
  InputEditor,
  SlickGrid,
  OnAddNewRowEventArgs,
  EditorValidator,
  CurrentSorter,
  EmitterType,
  OnEventArgs,
} from 'slickgrid-react';

import { ExcelExportService } from '@slickgrid-universal/excel-export';
import { OdataOption, OdataServiceApi } from '@slickgrid-universal/odata';


import BaseGrid, {BasicGridProps} from '../../components/grid/BaseGridComponent';
import { TextOperators } from '../../components/grid/CustomFilters/TextFilter';
import { SlickCustomTooltip } from '@slickgrid-universal/custom-tooltip-plugin';
import authService from '../../services/auth/auth.service';
import { LookupCollection, LookupData } from '../../components/grid/GridUtils';

import { withTranslation } from 'react-i18next';
import { InputAdornment, TextField } from '@mui/material';
import { useLocation } from 'react-router-dom';
import { useState } from 'react';
import BorderSpinner from '../../components/Layout/spinner';
import planService from '../../services/plan/plan.service';


const location = window.location
  
const locationley = location.pathname.replace('/', '')
const LOCAL_STORAGE_SEARCH = authService.getCurrentUser()?.shrt + '_crm-' + locationley + '-search' 

const resources = {
  en: {
    translation: translationEN
  },
  fr: {
    translation: translationFR
  },
  pl: {
    translation: translationPL
  }
};



class Plans extends BaseGrid {
  
    title = 'Plany';
    subTitle = 'Zarządzanie planami'
    lastApiCall : Date;
 constructor(public readonly props: BasicGridProps) {
    super(props);
    this.lastApiCall = new Date(0)
    
 }


setSearchFilter() {
  console.log('setSearchFilter')
  console.log(this.search_key)
  if (this.reactGrid && localStorage[this.search_key] && localStorage[this.search_key]!==''){
    this.reactGrid.filterService.updateFilters([])

  }else{
    if (this.reactGrid){
       this.reactGrid.filterService.clearFilters()
    }
  }
}

getplanlookups(){
  return PlanService.getplanlookups().then(response => {

        let tmp1: LookupCollection[] = []
        if ((response.data) && (Array.isArray(response.data))){
            tmp1  = response.data
        }
        this.setState((state: State) => ({
          ...state,
          lookupData : tmp1
        }),  () => {
          
            this.defineGrid()
        
          }
        );

   
  }
     
  ).catch(
    () => {
      let tmp : LookupData[] = [];
      this.setState((state: State, props: BasicGridProps) => ({
            ...state,
            alertError: "Nie wszystkie dane zostały poprawnie zaczytane - odśwież stronę!"
      }));
      return tmp;
    }
  )
}

  
onStorage = () => {
  this.setSearchFilter()
};
onFocus = () => {
  window.addEventListener("storage", this.onStorage)
};
onBlur = () => {
  window.removeEventListener("storage", this.onStorage)
};
  
componentDidMount() {
    window.addEventListener("resize",((e: any) =>{
      setTimeout(() => { this.reactGrid.resizerService.resizeGrid(); }, 1000);
      
  }).bind(this));

  window.addEventListener("focus", this.onFocus);
  window.addEventListener("blur", this.onBlur);
  this.onFocus();

 this.getplanlookups()

    i18next.init({
      lng: 'pl',
      debug: false,
      resources: resources
    }, (err, t) => {
      i18next.changeLanguage("pl");
      
    });
  
}

 defineGrid() {
    var presets = JSON.parse(localStorage[this.storage_key] || null);

    if (presets){
      var new_sorters = presets.sorters.map((element: CurrentSorter) => {
        element.columnId = (element.columnId as string).toLowerCase();
        return element;
      });
      presets.sorters = new_sorters;
    }
   
    var gridOptions =  this.getGridDefinition();
    gridOptions.presets = presets

    var columnDefinitions = this.getColumnDefinitions();

    this.setState((state: State) => ({
      ...state,
      gridOptions:gridOptions,
      columnDefinitions:columnDefinitions,
    
  }));
}

componentDidUpdate(PrevProps: any, prevState: State){
  if(this.state.alertErrorMsg !== prevState.alertErrorMsg){
      if (this.state.alertErrorMsg){
        //alert(this.state.alertErrorMsg)
      }
  }   
  
}


  getGridDefinition(): GridOption {    
      var tmp = super.getGridDefinition(this.state);
      tmp = {
        ...tmp,
        enableTranslate: true,
        i18n: i18next,
        autoResize: {
          container: '#smaller-container',
          rightPadding: 10
        },
        enableExcelExport : true,
        excelExportOptions: {
          sanitizeDataExport: true
        },
        externalResources: [this.excelExportService, this.compositeEditorInstance, new SlickCustomTooltip()],
        
        editCommandHandler: (_item:any, _column:Column<any>, editCommand:EditCommand) => {
          var data = _item
  
          this._commandQueue.push(editCommand);
          editCommand.execute();
          this.editPlanApiCall(data);
        },
        presets: {},
        
        backendServiceApi: {
          ...tmp.backendServiceApi,
          onError: (error: Error) => {
              this.setState((state: State, props: BasicGridProps) => ({
                ...state,
                alertError: "Błąd połączenia!"
              }));  
          },
          preProcess: () => {
            this.setState((state: State) => ({ ...state, errorStatus: '' }));
            this.displaySpinner(true);
          },
          process: (query) => {
            if (localStorage[this.search_key] && localStorage[this.search_key]!=''){
              query=query + "&$search=" + localStorage[this.search_key].replace('&', 'i') 
            }
            return this.getPlanApiCall(query)},
          postProcess: (response) => {
            if (new Date(response.metrics.startTime) > this.lastApiCall){
              this.lastApiCall = new Date(response.metrics.startTime)
              this.setState(
                (state: State) => ({ ...state, metrics: response.metrics }),
                () => this.postProcessCallback(response)
              );
            }
            this.displaySpinner(false);
          },
        } as OdataServiceApi
      }
    return tmp;
  }

  onCellValidationError(_e: Event, args: any) {
    if (args.validationResults) {
      this.setState((state: State, props: BasicGridProps) => ({
        ...state,
        alertWarning: args.validationResults.msg
      }));
    }
  }


  
nameFormatter = (row: any, cell: any, value: any, columnDef: any, dataContext: any) =>{
  let s=""
  if ( dataContext.name !=null){
    //s ="<a class='slickRowLink' href='/standeditor/" + dataContext.id + "' >" + dataContext.name + "</a>";
    const fragment = new DocumentFragment();
    const li = document.createElement("a");
    li.innerHTML = dataContext.name
    li.href = '/plans/standeditor/' + dataContext.id 
    li.target="_blank"
    fragment.append(li)
    return fragment
  }
  return s;
};

nameValidator :EditorValidator = (value: any) => {
  let ready=false
  if (value === null || value === undefined || !value.length) {
    return { valid: false, msg: 'To pole jest wymagane' };
  }else if (value.length>128) {
    return {
      valid: false,
      msg: 'To pole przyjmuje maksymalnie 128 znaków',
    };

  }
  
  return { valid: true, msg: '' };
};

sizeValidator :EditorValidator = (value: any) => {
  let ready=false
  if (value === null || value === undefined ) {
    return { valid: false, msg: 'To pole jest wymagane' };
  }else if (value < 10) {
    return {
      valid: false,
      msg: 'To pole musi być większe od 10',
    };

  }
  
  return { valid: true, msg: '' };
};




cardFormatter = function (row: any, cell: any, value: any, columnDef: any, dataContext: any) {
  //var s = " <a class='slickRowLink' href='/plans/edit/" + dataContext.id + "' >" + "Edytuj" + "</a>" + ", " + "<a class='slickRowLink' href='/plans/copy/" + dataContext.id + "' >" + "Kopiuj" + "</a>";
  
  const fragment = new DocumentFragment();
  const li_edt = document.createElement("a");
  li_edt.innerHTML = 'Edytuj'
  li_edt.href = '/plans/edit/' + dataContext.id
  li_edt.target="_blank"
  li_edt.className='slickRowLink'
  fragment.append(li_edt)

  const li_copy = document.createElement("a");
  li_copy.innerHTML = 'Kopiuj'
  li_copy.className='slickRowLink'
  li_copy.style.cssText = 'margin-left:5px'
  li_copy.onclick=()=>{
    planService.copyplan(dataContext.id).then(
      (data) => {
        window.location.reload()
      }
    ).catch(
         (error) => {
          alert('Wystąpił błąd przy kopiowaniu plau!')
        }
      )
  }
  li_copy.target="_blank"
  fragment.append(li_copy)
  return fragment
  
  //return s;
}

onTraderChange(e: Event, args: OnEventArgs){
  if (args.columnDef.field == 'trader_names_array'){
      if (Array.isArray(args.dataContext['trader_names_array']))
        args.dataContext['trader_names'] = args.dataContext['trader_names_array'].join(', ')
  }else{
    args.dataContext['trader_names'] = ''
  }
}


tradersFormatter =  (row: any, cell: any, value: any, columnDef: any, dataContext: any) => {
  var s="";
  if (dataContext.trader_names !=null){
      if (Array.isArray(dataContext.trader_names)){
          s = dataContext.trader_names.join(',');
      }else{
          var array = dataContext.trader_names.split(',');
          
          for (var a in array ) {
          if (s!=""){
              s+=", ";
          }	
          s +="<a class='slickRowLink' href='/plans?trader_name=" +  array[a] + "' >" + array[a] + "</a>";
          
          }
      }
  
  }
   return s;
};
 
  getColumnDefinitions(): Column[] {
    super.getColumnDefinitions()
    let tmp : Column[] = [];
    let data_plangroups : any[] = []; 
    let data_traders: any[] = [];
    this.state.lookupData?.forEach((item) => {
      if (item.name === 'plangroups'){
        data_plangroups = item.data; 
      }else if (item.name === 'traders'){
        data_traders = item.data; 
      }
    }) 

    if (authService.isAdmin()){
      tmp.push(
        {
          id: 'delete', field: 'id',
          excludeFromColumnPicker: true, excludeFromGridMenu: true,excludeFromHeaderMenu: true,
          formatter: Formatters.icon, params: { iconCssClass: 'fa fa-trash pointer' }, minWidth: 30, maxWidth: 30,  
          customTooltip: {
            formatter:  this.deleteFormatter.bind(this) as Formatter
          },    
        }
      );
    }

    tmp.push(
      {
        id: 'row_no', name: 'Lp.', field: 'row_no', sortable: false, filterable: false,
        type: FieldType.integer,
        minWidth:30 ,
        maxWidth:50    
      },
      {
        id: 'name', name: 'Nazwa', field: 'name', sortable: true, filterable: true,
        type: FieldType.string,
        formatter:this.nameFormatter,
        excludeFromColumnPicker: true,
        //formatter:this.taskTranslateFormatter,
        filter: {model: Filters.compoundInput, compoundOperatorList: TextOperators},       
        editor: {model: Editors.text,
          validator : this.nameValidator,
          maxLength:128,
          compositeEditorFormOrder : 1,
          
        },
        hidden:false,
        minWidth:  100 
        
      },
      {
        id: 'id', name: 'Nr planu', field: 'id', sortable: true, filterable: true,
        type: FieldType.integer,
        minWidth:30 ,
        maxWidth:50    
      },
      {
        id: 'date', name: 'Data wydarzenia', field: 'date', sortable: true, filterable: true,
        type: FieldType.dateTimeIso,
        formatter:Formatters.dateTimeIso,
        editor: {model: Editors.date,
          compositeEditorFormOrder : 2,
          editorOptions:{enableTime:true},
          massUpdate: true,
          
        },
        
        filter: {model: Filters.dateRange, filterOptions:{enableTime:false}},           
        hidden:false,
        minWidth:100
             
      },
     /* {
        id: 'size', name: 'Wymiary', field: 'size', sortable: true, filterable: true,
        excludeFromColumnPicker: true,
        type: FieldType.string,
        filter: {model: Filters.compoundInput, compoundOperatorList: TextOperators},
        minWidth:100
      },*/
      {
        id: 'width', name: 'Szerokość [m]', field: 'width', sortable: true, filterable: true,
        excludeFromColumnPicker: true,
        editor:{
          model: Editors.integer,
          validator : this.sizeValidator,
        },
        type: FieldType.number,
        filter: {model: Filters.compoundInput, compoundOperatorList: TextOperators},
        minWidth:100
      },
      {
        id: 'height', name: 'Wysokość [m]', field: 'height', sortable: true, filterable: true,
        excludeFromColumnPicker: true,
        editor:{
          model: Editors.integer,
          validator : this.sizeValidator,
        },
        type: FieldType.string,
        filter: {model: Filters.compoundInput, compoundOperatorList: TextOperators},
        minWidth:100
      },
      {
        id: 'card', name: 'Karta', field: '', sortable: false, filterable: false,
        excludeFromColumnPicker: true,
        formatter:this.cardFormatter,
        type: FieldType.string,
        minWidth:100
      },
      {
        id: 'trader_names_array', name: 'Handlowcy', field: 'trader_names_array', sortable: true, filterable: true,
        type: FieldType.string,
        formatter: this.tradersFormatter,
        filter: {model: Filters.multipleSelect, compoundOperatorList: TextOperators, collection:data_traders},
        editor: {model: Editors.multipleSelect,
          collection: data_traders,
          compositeEditorFormOrder : 7,
        },
        onCellChange: this.onTraderChange,
        queryField: 'trader_names',
        minWidth:100
      },

      {
        id: 'openedusername', name: 'Edytowany przez', field: 'openedusername', sortable: true, filterable: true,
        type: FieldType.string,
        excludeFromColumnPicker: true,
        //formatter:this.taskTranslateFormatter,
        filter: {model: Filters.compoundInput, compoundOperatorList: TextOperators},       
       
        hidden:false,
        minWidth:  100 
        
      },

      {
        id: 'openeddate', name: 'Edytowany od', field: 'openeddate', sortable: true, filterable: true,
        type: FieldType.dateTimeIso,
        formatter:Formatters.dateTimeIso,
        
        filter: {model: Filters.dateRange, filterOptions:{enableTime:false}},           
        hidden:false,
        minWidth:100
             
      },

      {
        id: 'color_stand', name: 'Kolor wykładzin', field: 'color_stand', sortable: true, filterable: false,
        type: FieldType.string,
        formatter:this.colorFormatter,
        editor:{model:ColorStandEditor},         
        hidden:false,
        minWidth:100
             
      },

      {
        id: 'color_wall', name: 'Kolor ścian', field: 'color_wall', sortable: true, filterable: false,
        type: FieldType.string,
        formatter:this.colorFormatter,
        editor:{model:ColorWallEditor},         
        hidden:false,
        minWidth:100
             
      },

      {
        id: 'plangroupname', name: 'Grupa', field: 'plangroupname', sortable: true, filterable: true,
        type: FieldType.string,
        filter: {model: Filters.multipleSelect, collection:data_plangroups, compoundOperatorList: TextOperators},
        editor: {model: Editors.singleSelect,
          collection: data_plangroups,
          massUpdate: true,
          compositeEditorFormOrder : 6,
        },
        
        minWidth:100
      },




      
    );
    tmp = this.customizeHeaderMenu(tmp)
    return tmp
  }


  deleteFormatter(row: number, cell: number, value: any, column: Column, dataContext: any, grid: SlickGrid) {
    const tooltipTitle = 'Usuń';
    return `<div class="header-tooltip-title">${tooltipTitle}</div>
    <div class="tooltip-2cols-row"><div>Etykieta:</div> <div>${dataContext.name}</div></div>`;
  }

  getPlanApiCall(query: string) {
    return PlanService.getplans(query)
  }
  editPlanApiCall(data: any) {   
    PlanService.editplan(data).then(
      
      ).catch(
         (error) => {
          try{
            this._commandQueue.pop()?.undo()
            this.setState((state: State, props: BasicGridProps) => ({
              ...state,
              alertError: "Błąd edycji danych"
            }));
          }catch{

          }
        }
      )
  }

  sortCollectionDescending(collection: any[]) {
    return collection.sort((item1, item2) => item1.value - item2.value);
  }

  openCompositeModal(modalType: CompositeEditorModalType) {
    let modalTitle = '';
    if (this.reactGrid.slickGrid.getEditorLock().isActive() && !this.reactGrid.slickGrid.getEditorLock().commitCurrentEdit()) {
      return;
    }
      switch (modalType) {
        case 'create':
          modalTitle = 'Dodawanie nowego planu';
          break;
        case 'clone':
          modalTitle = 'Kopiowanie planu - {{name}}';
          break;
        case 'edit':
          var selecttedcount =  this.reactGrid.slickGrid.getSelectedRows();
          if (selecttedcount.length > 1){
            modalTitle = 'Edycja wybranych planów (' + selecttedcount + ')';
            modalType = 'mass-selection';
          }else{
            modalTitle = 'Edycja planu {{title}}' // ({{product.itemName}})'
          }
          break;
      }
      var modalColumns = this.reactGrid.slickGrid.getColumns(). filter(col => col.editor);

    if (modalType==='edit'){
      if (this.reactGrid.slickGrid.getSelectedRows() && (this.reactGrid.slickGrid.getSelectedRows().length===1)){
        this.compositeEditorInstance?.openDetails({
          headerTitle: modalTitle,
          modalType,
          insertOptions: { highlightRow: false }, 
          showFormResetButton: true,
          resetFormButtonIconCssClass: 'fa fa-undo',
          
          onClose: () => Promise.resolve(window.confirm('Istnieją niezapisane zmiany, czy na pewno chcesz wyjść bez zapisywania zmian?')),
          onError: (error) => alert(error.message),
        });
      }else if (this.reactGrid.slickGrid.getSelectedRows() && (this.reactGrid.slickGrid.getSelectedRows().length>1)){
        alert('Wybież jeden plan do edycji!');
      }else{
        alert('Nie wybrano planu do edycji!');
      }
    }else{
        this.compositeEditorInstance?.openDetails({
            headerTitle: modalTitle,
            modalType,
            insertOptions: { highlightRow: false }, 
            showFormResetButton: true,
            resetFormButtonIconCssClass: 'fa fa-undo',
          
            
          onClose: () => Promise.resolve(window.confirm('Istnieją niezapisane zmiany, czy na pewno chcesz wyjść bez zapisywania zmian?')),
          onError: (error) => alert(error.message),
          onSave: (formValues, _selection: CompositeEditorSelection, dataContext) => {
            if (_selection.gridRowIndexes.length===0){
              let tmp = {...dataContext, id:null}
              if (tmp.date == '' || tmp.date == null){
                  tmp.date = null
              }
              console.log(tmp)
              PlanService.addplan(tmp).then(
                  (data) => {
                    this.reactGrid.filterService.updateFilters([])
                  }
                ).catch(
                  (error) => {
                    try{   
                      if (error && error.response && error.response.data && error.response.data.detail){
                        this.setState((state: State, props: BasicGridProps) => ({
                          ...state,
                          alertError: "Błąd: " + error.response.data.detail
                        }));
                      }else{          
                        this.setState((state: State, props: BasicGridProps) => ({
                          ...state,
                          alertError: "Błąd podczas dodawania planu"
                        }));
                      }
                     
                      var tmp = this.reactGrid.slickGrid.getData().getItems()
                      tmp.splice(0,1);
                      
                      this.reactGrid.slickGrid.getData().setItems(tmp)
                    }catch{
          
                    }
                  }
                )   
            }
          const serverResponseDelay = 50;
          return new Promise(resolve => setTimeout(() => resolve(true), serverResponseDelay));
        }
      });
    }
  }
    
  onCellClicked(_e: Event, args: any) {
    const metadata = this.reactGrid.gridService.getColumnFromEventArguments(args);

    if (metadata.columnDef.id === 'delete') {
      
      if (window.confirm('Czy potwierdzasz usunięcie planu: ' + metadata.dataContext.name + '?')) {
        PlanService.deleteplan(metadata.dataContext.id).then(
          () => {
            this.reactGrid.gridService.deleteItemById(metadata.dataContext.id)

            this.setState((state: State, props: BasicGridProps) => ({
              ...state,
              alertInfo: `Usunięto plan: ${metadata.dataContext.name}`,
            }));
        }

        ).catch(
          () => {
            this.setState((state: State, props: BasicGridProps) => ({
              ...state,
              alertError: `Wystąpił problem przy usuwaniu planu: ${metadata.dataContext.name}`,
            }));
          }
        )
        
        
      }
    }
  }

  checkItemIsEditable(dataContext: any, columnDef: Column, grid: SlickGrid) {
    const gridOptions = grid.getOptions() as GridOption;
    const hasEditor = columnDef.editor;
    const isGridEditable = gridOptions.editable;
    let isEditable = Boolean(isGridEditable && hasEditor);
   // if (columnDef.field=='height' || columnDef.field=='width'){
   //   isEditable = false
   // }
  
    //if (dataContext && columnDef && gridOptions?.editable) {
    //  isEditable = authService.isAdmin() 
   //}
    return isEditable;
  }

  handleonAddNewRow(_e: Event, args: OnAddNewRowEventArgs) {
     //return true;
  }

  handleOnCompositeEditorChange(_e: Event, args: OnCompositeEditorChangeEventArgs) {
    
  }

  handleOnBeforeEditCell(e: Event, args: any) {
    const { column, item, grid } = args;

    if (column && item && !this.checkItemIsEditable(item, column, grid)) {
      e.stopImmediatePropagation();
      return false;
    }
    return true;
  }

  resizeContent($event:any){
 
  }

  render() {
    if (this.state.alertWarning) {
      enqueueSnackbar(this.state.alertWarning, {variant: 'warning', preventDuplicate: true, autoHideDuration:5000, persist: false})
      this.setState((state: State, props: BasicGridProps) => ({
        ...state,
        alertWarning: ''
      }));
    }
    if (this.state.alertError) {
      enqueueSnackbar(this.state.alertError, {variant: 'error', preventDuplicate: true, autoHideDuration:5000, persist: false})
      this.setState((state: State, props: BasicGridProps) => ({
        ...state,
        alertError: ''
      }));
    }

    if (this.state.alertInfo) {
      enqueueSnackbar(this.state.alertInfo, {variant: 'info', preventDuplicate: true, autoHideDuration:5000, persist: false}) 
      this.setState((state: State, props: BasicGridProps) => ({
        ...state,
        alertInfo: ''
      }));
    }

    return !this.state.gridOptions ? '' : (
       <>
          <div className="gridMenu">
            <div className='gridLeftSubMenu'> 
              <FormControlLabel id="lblautoedit" control={<Switch checked={this.state.isAutoEdit} onChange={(_, data) => this.autoeditchange(data)}  />} label="Auto-edit" />
                    
            </div>
            
            
            
            <div className='gridCenterSubMenu'>
            
           { authService.isAdmin() && <button className="btn btn-outline-secondary btn-sm mx" data-test="clear-sorting"
                  onClick={() => {this.openCompositeModal('create')} 
            }>
                  Dodaj
                </button>
            }
           
              
            <button className="btn btn-outline-secondary btn-sm mx-1" data-test="clear-sorting"
              onClick={() => this.openCompositeModal('edit')}>
                Edytuj
            </button>
              
            </div><div className='gridRightSubMenu'>
                <button className="btn btn-outline-secondary btn-sm mx-1" data-test="set-dynamic-sorting"
                  onClick={() => this.setFactorySettings()}>
                  Ustawienia domyślne
                </button>

              </div>
          </div>
          <div id="smaller-container" onResize={this.resizeContent} style={{ width: '100%' }}>
          {this.state.status.text =='loading' ? <BorderSpinner/> : ''}
          
          <SlickgridReact gridId="plan-grid"
            columnDefinitions={this.state.columnDefinitions}
            gridOptions={this.state.gridOptions}
            dataset={this.state.dataset}
            paginationOptions={this.state.paginationOptions}
            onReactGridCreated={$event => this.reactGridReady($event.detail)}
            onGridStateChanged={$event => this.gridStateChanged($event.detail)}
            onClick={e => { this.onCellClicked(e.detail.eventData, e.detail.args); }}  
            onBeforeEditCell={$event => this.handleOnBeforeEditCell($event.detail.eventData, $event.detail.args)}   
            onCompositeEditorChange={$event => this.handleOnCompositeEditorChange($event.detail.eventData, $event.detail.args)}
            onAddNewRow={$event => this.handleonAddNewRow($event.detail.eventData, $event.detail.args)}
            onValidationError={e => { this.onCellValidationError(e.detail.eventData, e.detail.args); }}
            
            
          />
          </div>
      </>
    );
  }
}

export default withTranslation()(Plans);


